import { createFileRoute, redirect } from '@tanstack/react-router'
import { StockScreen } from '@/features/inventory-stock/stock-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/stock')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock.view')) throw redirect({ to: '/' })
  },
  component: StockScreen,
})
